import { Alert, Box, Typography } from '@mui/material';

export function PlaceholderPanel({ title, message }) {
  return (
    <Box sx={{ py: 2 }}>
      {title && (
        <Typography variant="subtitle1" gutterBottom>
          {title}
        </Typography>
      )}
      <Alert severity="info" variant="outlined">
        {message}
      </Alert>
    </Box>
  );
}
